/** Set to `true` to restore Binance Pay on method selection. */
export const isBinancePayOfferingEnabled = false;
